export const isObject = item => {
  return typeof item === 'object' && item !== null;
};
